import { createFileRoute } from '@tanstack/react-router';
import { listSearchSchema } from '@/lib/list-search-schema';
import Tasks from '@/pages/Tasks';

export const Route = createFileRoute('/_authenticated/tasks')({
  validateSearch: listSearchSchema,
  component: Tasks,
});
